import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { CaptureContext } from '@sentry/types';

@Injectable({
    providedIn: 'root',
})
export class SentryService {
    public capture(eventOrError: Error, context?: CaptureContext) {
        Sentry.captureException(eventOrError, context);
    }

    public configureScope(user: { username: string; email: string }) {
        Sentry.configureScope((scope) => {
            scope.setUser({
                id: user.username,
                username: user.username,
                email: user.email,
            });
        });
    }

    public resetScope() {
        Sentry.configureScope((scope) => {
            scope.setUser(null);
        });
    }
}
